import { render, staticRenderFns } from "./PriceCreationComponent.vue?vue&type=template&id=6d4eed2a&scoped=true&"
import script from "./PriceCreationComponent.vue?vue&type=script&lang=js&"
export * from "./PriceCreationComponent.vue?vue&type=script&lang=js&"
import style0 from "./PriceCreationComponent.vue?vue&type=style&index=0&id=6d4eed2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4eed2a",
  null
  
)

export default component.exports